import { memo } from 'react';
import cn from 'classnames';
import { Button, Element, IconButton, Title } from 'src/components';
import Card from 'src/components/card';

const MAP_STATE = {
    fail: {
        title: 'Không thể thực hiện',
        content: 'Đã có lỗi xảy ra, bạn vui lòng thực hiện lại',
    },
    success: {
        title: 'Đã gửi thông tin',
        content:
            'Cám ơn bạn đóng góp ý kiến. Chúng tôi sẽ kiểm tra lại nội dung trong thời gian sớm nhất.',
    },
};

export default memo(function ModalSuccess({ hide, reportState }: any) {
    const responseStatus = reportState.value ? 'success' : 'fail';
    const { title, content } = MAP_STATE[responseStatus];

    return (
        <Card>
            <Card.Header
                className={cn(
                    'relative',
                    'flex items-center',
                    'px-[30px]',
                    'h-[52px]',
                    'border-b border-solid border-[#E9ECEF]',
                    'rounded-t-[12px]',
                    'bg-[#F8F9FA]',
                )}
            >
                <Title className={'text-[20px] font-[800]'}>{title}</Title>
                <IconButton
                    onClick={hide}
                    icon="new-x-close-light"
                    className={cn(
                        'absolute top-1/2 right-[8px]',
                        '-translate-y-1/2',
                        'p-[4px]',
                    )}
                    classNameIcon="text-[12px] text-[#131214]"
                />
            </Card.Header>
            <Card.Content className={cn('p-[24px_30px_20px]', 'text-center')}>
                <Element
                    className={
                        'text-[16px] leading-[1.5] text-[#131214] font-[600]'
                    }
                >
                    {content}
                </Element>
            </Card.Content>
            <Card.Footer
                className={cn(
                    'flex-nowrap justify-center',
                    'h-auto',
                    'rounded-none',
                    'text-center',
                    'p-[0_30px_24px] mt-0',
                )}
            >
                <Button
                    className={cn(
                        'rounded-[8px]',
                        'w-1/2 h-auto',
                        'text-[16px] leading-[1] font-bold',
                        'py-[12px]',
                    )}
                    title="Đóng"
                    color={'primary'}
                    onClick={hide}
                >
                    Đóng
                </Button>
            </Card.Footer>
        </Card>
    );
});
